import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ScrollToTop from "../components/ScrollToTop";
import { Box } from "@chakra-ui/react";

const MainLayout = ({ children }) => {
  return (
    <>
      <Header />
      <ScrollToTop />
      <main>{children}</main>
      <Footer />
    </>
  );
};

export default MainLayout;
